export const GA_BUTTON_EVENT = "button_click";
export const GA_PDF_DOWNLOAD = "PDF_Download";
export const GA_DOCS_AND_IMAGES_DOWNLOAD = "docs_images_download";
export const GA_TECHNICAL_REPORT_DOWNLOAD = "Part_B_download";
export const GA_SHARE_ICON = "share_icon";
export const GA_SHARE_CLIPBOARD = "share_clipboard";
export const GA_TAB_SUMMARY = "tab_summary";
export const GA_TAB_PARTICULARS = "tab_particulars";
export const GA_TAB_ITEMS = "tab_NI";
export const GA_TAB_GRADING = "tab_grading";
export const GA_TAB_DECARBONISATION = "tab_decarbonisation";
export const GA_TAB_DOCUMENTS = "tab_documents";
export const GA_TAB_SUPPLEMENTS = "tab_supplements";
export const GA_IMAGE_CAROUSEL = "image_carousel_click";
export const GA_DOCUMENTS_DOWNLOAD_SELECTED = "docs_download_selected";
export const GA_NI_IMAGE = "ni_image";
export const GA_ACCORDION_TAB = "grading_accordion";
export const GA_TAB_GRADE_COMPARISON = "tab_grade_comparison";
export const GA_VIEW_REPORT = "view_report_button";
export const GA_CLICK_SHARE_OPTIONS = "click_share_options";

const TAB_ENUM = {
    SUMMARY: 0,
    PARTICULARS: 1,
    NOTABLE_ITEMS: 2,
    GRADING: 3,
    DECARBONISATION: 4,
    DOCUMENTS: 5,
    SUPPLEMENTS: 6,
    GRADE_COMPARISON: 7,
}


export const actionMap: { [name: string]: string } = {
    [TAB_ENUM.SUMMARY]: GA_TAB_SUMMARY,
    [TAB_ENUM.PARTICULARS]: GA_TAB_PARTICULARS,
    [TAB_ENUM.NOTABLE_ITEMS]: GA_TAB_ITEMS,
    [TAB_ENUM.GRADING]: GA_TAB_GRADING,
    [TAB_ENUM.DOCUMENTS]: GA_TAB_DOCUMENTS,
    [TAB_ENUM.SUPPLEMENTS]: GA_TAB_SUPPLEMENTS,
    [TAB_ENUM.GRADE_COMPARISON]: GA_TAB_GRADE_COMPARISON
}